/**
 * List Schema of MotoristaResponsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {MotoristaResponsavel} from '@/model/resource/MotoristaResponsavel'

/* TODO: review generated schema */
export class ListMotoristaResponsavelSchema extends Schema {
  readonly name = 'ListMotoristaResponsavel'

  readonly fieldSet: FieldSet<MotoristaResponsavel> = {
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    apelido: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
